import _ from 'lodash';

export default function selector(storeState) {
    const draft = _.get(storeState, 'adminOrgForm.draft');
    const errors = _.get(storeState, 'adminOrgForm.errors');
    const showErrors = _.get(storeState, 'adminOrgForm.showErrors');
    return {
        draft,
        errors,
        showErrors,
    };
}
